var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGraduate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,56.75h35c6.479,0,11.75,5.94385,11.75,13.25h1.5c0-8.1333-5.94385-14.75-13.25-14.75h-35C15.19385,55.25,9.25,61.8667,9.25,70h1.5C10.75,62.69385,16.021,56.75,22.5,56.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25,30v6.57129C23.25,45.49219,30.76416,52.75,40,52.75s16.75-7.25781,16.75-16.17871V16.75H68.28564v-1.5H11.71436v1.5H17.25V36.5625h1.5V16.75h4.5V30Zm1.5-13.25h30.5V28.64648c-5.68262-3.32226-11.26465-3.21044-15.25488.32813A12.3538,12.3538,0,0,0,32,26.24072a12.685,12.685,0,0,0-7.25,2.15479Zm0,13.58521A10.655,10.655,0,0,1,32,27.75a10.55181,10.55181,0,0,1,7.46973,2.78027.74972.74972,0,0,0,1.06054,0C44.192,26.8681,49.67358,26.8396,55.25,30.41492v6.15637C55.25,44.665,48.40869,51.25,40,51.25S24.75,44.665,24.75,36.57129Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraduate);
export default __webpack_public_path__ + "static/media/icon_graduate.3794be67554d29ff8ccd3d44da1f591a.svg";
export { ForwardRef as ReactComponent };